import styled from 'styled-components';

export const Container = styled.section`
  display: grid;
  grid-template-columns: 3fr 2fr;
  justify-items: center;
  gap: 30px;
  margin: 0 25px;
  border-bottom: 1px solid black;

  @media (max-width: 1000px) {
    grid-template-columns: auto;
  }
`;

export const AboutMe = styled.div`
  padding: 60px 5%;
  
  p {
    font-size: 18px;
  }

  @media (max-width: 425px) {
    padding: 0px 5%;
  }
`;

export const Profile = styled.div`
  width: 100%;
  position: relative;
  display: grid;
  justify-items: center;
  padding: 75px;

  @media (max-width: 425px) {
    .fa--node,
    .fa--jest,
    .fa--git,
    .fa--csharp,
    .fa--gitlab {
      display: none;
    }
  }
`;

export const Skills = styled.section`
  margin: 20px 0;
  padding: 20px 0;
  border-top: 1px solid ${props => props.theme.darkGray};
  border-bottom: 1px solid ${props => props.theme.darkGray};

  button {
    width: 100%;
    height: 70px;
    color: white;
    font-size: 20px;
    font-weight: 600;
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen',
      'Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    background: ${props => props.theme.darkGray};
    border: none;
    cursor: pointer;
  }

  i {
    padding: 0 20px;
  }

  article {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    padding: 50px 10%;
    background: ${props => props.theme.borderGray}
    box-shadow: inset 0px 100px 29px -85px rgba(0,0,0,0.3),
      inset 0px -100px 29px -85px rgba(0,0,0,0.3);
  }

  ul {
    display: grid;
    justify-content: center;
    justify-items: center;
    position: relative;
    border-radius: 7px;
    padding: 0;
    color: white;
    border-left: 1px solid white;
    border-right: 1px solid white;
  }

  ul i {
    width: 50px;
    height: 50px;
    font-size: 20px;
    color: white;
    display: grid;
    align-items: center;
    justify-content: center;
    padding: 10px;
    background: ${props => props.theme.darkGray};;
    border-radius: 55px;
    position: absolute;
    top: -30px;
  }
  
  h4 {
    padding: 20px 10px 5px 10px;
    background: 1px solid ${props => props.theme.borderGray};
    width: 100%;
    font-size: 18px;
    border-radius: 5px 5px 0 0;
    color: white;
    text-align: center;
  }

  h4, h5 {
    margin: 0
  }

  p {
    text-align: center;
    padding: 0 10px;
  }

  @media (max-width: 1000px) {
    article {
      grid-template-columns: auto;
    }
  }
`;
